module.exports = __webpack_public_path__ + "assets/099ca84f1674eb364eba295e887e35c4.png";